import type { App } from 'vue'
import HelloWorld from './components/HelloWorld.vue'  
import RanaSignin from './components/ranaSignIn.vue'
import ranaSignInMarket from './components/ranaSignInMarket.vue'
import LoadImg from './components/LoadImg.vue'
import { useDeviceStore } from './stores/device'

// named exports
export { HelloWorld, useDeviceStore, RanaSignin, ranaSignInMarket,LoadImg }

// allow global install via app.use()
export default {
  install(app: App) {
    app.component('HelloWorld', HelloWorld)
    app.component('RanaSignin', RanaSignin)
    app.component('ranaSignInMarket', ranaSignInMarket)
    app.component('LoadImg', LoadImg)
  }
}
